import colors from 'tailwindcss/colors';
import React, { useEffect, useRef, useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import GlobalConsts from '../Constants/GlobalConsts';

ChartJS.register(ArcElement, Tooltip, Legend);

function DougnutChart(props) {

    const canvasRef = useRef(null);
    const [ctx, setCtx] = useState(undefined);
    const theme = useSelector((state) => state.auth.theme);
    const chartData = props.chartData || [];
    const interval = props.interval || '';

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctxObj = canvas.getContext("2d");
        setCtx(ctxObj);
    }, []);


    useEffect(() => {
        console.log(theme);
    }, [theme]);

    const getGradientColor = (color) => {
        const gradient = ctx?.createLinearGradient(0, 0, 0, canvasRef?.height || 150);
        gradient?.addColorStop(0, `rgba(${color},0.3)`);
        gradient?.addColorStop(0.8, `rgba(${color},0.05)`);
        gradient?.addColorStop(1, `rgba(${color},0)`);
        return gradient;
    }

    const options = () => {

        const textColor = theme === GlobalConsts.LIGHT ? colors.gray['800'] : colors.gray['100'];
        return {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                tooltip: {
                    enabled: true,
                },
                legend: {
                    display: false,
                    position: 'top',
                    align: 'start',
                    labels: {
                        boxHeight: 2
                    }
                },
                title: {
                    display: false,
                },
            },
            // scales: {
            //     x: {
            //         display: false,
            //         ticks: {
            //             color: textColor,
            //             padding: 4,
            //             font: {
            //                 family: "'Mulish', sans-serif",
            //                 size: 12,
            //             },
            //         },
            //         grid: {
            //             lineWidth: 4,
            //             color: "rgba(0, 0, 0, 0.01)",
            //             display: false
            //         },
            //         border: {
            //             display: false
            //         },
            //     },
            //     y: {
            //         beginAtZero: false,
            //         min: -25,
            //         grace: '20%',
            //         ticks: {
            //             padding: 4,
            //             steps: 4,
            //             stepValue: 5,
            //             max: 100,
            //             color: textColor,
            //             font: {
            //                 family: "'Mulish', sans-serif",
            //                 size: 0,
            //             },
            //         },
            //         grid: {
            //             drawBorder: false,
            //             lineWidth: 4,
            //             color: "rgba(0, 0, 0, 0.01)",
            //             display: false,

            //         },
            //         border: {
            //             display: false
            //         },

            //     }
            // },
        }
    };

    const labels = chartData && chartData.length>0 && chartData.map((elem) => {return elem.points});

    // const labels = chartData.map((elem) => {
    //     let options;
    //     switch (interval) {
    //         case 'DAY':
    //             options = { month: 'long', day: 'numeric' };
    //             break;
    //         case 'MONTH':
    //             options = { month: 'long', year: 'numeric' };
    //             break;
    //         default:
    //             options = { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    //     }
    //     const dateTime = new Date(elem.clickTime);
    //     const localDateString = dateTime.toLocaleDateString('en-US', options);
    //     return localDateString;
    // });

    const data = (canvas) => {

        return {
            labels,
            datasets: [
                // {
                //     fill: true,
                //     label: 'Credit',
                //     data: chartData.map((rawData) => { return Math.floor(Math.random() * 100) }),
                //     // data: chartData.map((rawData) => { return rawData.credit }),
                //     borderColor: 'rgb(124, 58, 273)',
                //     // backgroundColor: 'rgba(124, 58, 273,0.2)',
                //     backgroundColor: getGradientColor('124, 58, 273'),
                //     borderWidth: 4,
                //     pointBorderWidth: 0,
                //     pointHitRadius: 30,
                //     tension: 0.15
                // },
                {

                    fill: true,
                    label: 'Clicks',
                    data: chartData && chartData.length>0 && chartData.map((rawData) => { return rawData.clicks }),
                    // data: chartData.map((rawData) => { return Math.floor(Math.random() * 100) }),
                    // backgroundColor: getGradientColor('124, 150, 273'),
                    borderColor: 'rgb(124, 150, 273)',
                    backgroundColor: 'rgba(124, 150, 273,0)',
                    borderWidth: 4,
                    pointBorderWidth: 0,
                    pointHitRadius: 30,
                    tension: 0.15
                },
            ],
        };
    };


    return (

        <div>
            <canvas ref={canvasRef} height={0} />
            <div className="flex w-full h-44 text-left p-6  ">
                <Doughnut options={options()} data={data(canvasRef.current)} />
            </div>
        </div>
    );
}

export default DougnutChart;
